import { render } from "./LogistsTab.vue?vue&type=template&id=543a81e4&scoped=true"
import script from "./LogistsTab.vue?vue&type=script&lang=js"
export * from "./LogistsTab.vue?vue&type=script&lang=js"

import "./LogistsTab.vue?vue&type=style&index=0&id=543a81e4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-543a81e4"]])

export default __exports__